export default "__VITE_ASSET__b261aeae__"